


































































import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import PlusMinusCollapseOpener from '~/components/shared/configurable/collapse/PlusMinusCollapseOpener.vue'
import CImg from '~/components/shared/configurable/image/CImg.vue'
import CCollapse from '~/components/shared/configurable/collapse/CCollapse.vue'
import { useI18n } from '~/compositions/i18n'
import { defineComponentTranslations } from '~/utils/i18n'
import { getUnitIconType } from '~/utils/inhouse'
import AdUnitSizeString from '~/components/shared/advertising/AdUnitSizeString.vue'
import { useStatic } from '~/compositions/useStatic'

export default defineComponent({
  i18n: defineComponentTranslations({
    watch_example: {
      en: 'Watch live example',
      el: 'Δες live παράδειγμα'
    }
  }),
  components: { AdUnitSizeString, CCollapse, CImg, PlusMinusCollapseOpener },
  props: {
    expandAll: { type: Boolean, default: false },
    expandFirst: { type: Boolean, default: false },
    unitOptions: { type: Object, required: true },
    showPixels: { type: Boolean, default: false, required: false }
  },
  setup(props) {
    const { unitOptions } = toRefs(props)
    const { t } = useI18n()
    const s = useStatic()

    const advices = computed(() => {
      const options = { ...unitOptions.value }
      if (options) {
        Object.keys(options).forEach(key => {
          options[key] = options[key].map(u => {
            const labelString = t(`${u.value}_description`)
            const split = labelString.split(',')
            const label = {
              bold: split[0],
              rest: split.length > 1 ? split[1] : undefined,
              type: getUnitIconType(u.value)
            }
            return {
              ...u,
              label,
              imageUrl: s(
                `/nuxt-static/img/advertise/previews/${u.value}_preview.png`
              )
            }
          })
        })
        return options
      }
      return []
    })

    return {
      advices
    }
  }
})
